import {
  IonBadge,
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonSegment,
  IonSegmentButton,
  IonText,
  useIonToast,
} from "@ionic/react";
import { add, arrowBackOutline } from "ionicons/icons";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Header from "src/components/Header";
import {
  SolicitudFila,
  colorEstado,
  estaAbierta,
  etiquetaEstado,
  listarMisSolicitudes,
} from "src/services/solicitudesRRHH";

type Filtro = "pendientes" | "resueltas";

const SolicitudesRRHHMis: React.FC = () => {
  const history = useHistory();

  // Se entra desde el hub de departamentos (/solicitudes), asi que la flecha
  // vuelve ahi en vez de dejar solo el boton de menu.
  const botonVolver = {
    icono: arrowBackOutline,
    action: () => history.push("/solicitudes"),
  };
  const [present] = useIonToast();
  const [solicitudes, setSolicitudes] = useState<SolicitudFila[]>([]);
  const [filtro, setFiltro] = useState<Filtro>("pendientes");
  const [cargando, setCargando] = useState(false);

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const lista = await listarMisSolicitudes();
      setSolicitudes(lista);
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Error al cargar";
      present({ message: msg, duration: 3000, color: "danger" });
    } finally {
      setCargando(false);
    }
  }, [present]);

  useEffect(() => {
    void cargar();
  }, [cargar]);

  // "Pendientes" es todo lo que sigue abierto, y eso lo decide EMSYS (ver
  // estaAbierta). Antes esta pantalla tenia su propia lista de estados y
  // quedo vieja: una solicitud devuelta para corregir aparecia como resuelta,
  // que es justo la que hay que mirar.
  const visibles = solicitudes.filter((s) =>
    filtro === "pendientes" ? estaAbierta(s) : !estaAbierta(s),
  );

  return (
    <IonPage>
      <Header titulo="Solicitudes a RRHH" botonIzq={botonVolver} />
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={async (e) => {
          await cargar();
          e.detail.complete();
        }}>
          <IonRefresherContent />
        </IonRefresher>

        <IonSegment
          value={filtro}
          onIonChange={(e) => setFiltro((e.detail.value as Filtro) || "pendientes")}
        >
          <IonSegmentButton value="pendientes">
            <IonLabel>Pendientes</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="resueltas">
            <IonLabel>Resueltas</IonLabel>
          </IonSegmentButton>
        </IonSegment>

        <IonLoading isOpen={cargando} message="Cargando..." />

        {visibles.length === 0 && !cargando && (
          <IonText color="medium">
            <div style={{ padding: "2rem", textAlign: "center" }}>
              {filtro === "pendientes"
                ? "No tenes solicitudes pendientes."
                : "Todavia no tenes solicitudes resueltas."}
            </div>
          </IonText>
        )}

        <IonList>
          {visibles.map((s) => (
            <IonItem
              key={s.id}
              button
              onClick={() => history.push(`/solicitudes-rrhh/${s.id}`)}
            >
              <IonLabel>
                <h2>{s.motivo_texto}</h2>
                {s.colaborador && <p>{s.colaborador}</p>}
                {s.punto_servicio && <p>{s.punto_servicio}</p>}
                <p>
                  #{s.id} &middot; {s.fecha_registro}
                </p>
              </IonLabel>
              <IonBadge slot="end" color={colorEstado(s.estado)}>
                {etiquetaEstado(s.estado)}
              </IonBadge>
            </IonItem>
          ))}
        </IonList>

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => history.push("/solicitudes-rrhh/nueva")}>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default SolicitudesRRHHMis;
